import { GRPC_CODE, isRestError, isValidationError } from '@monorepo/rest-client';
import { restClient } from '../../../core/network/restClient';

const PUBLIC_WARRANTY_PATH = '/api/v1/public/warranty';

// BE trả "không tìm thấy phiếu bảo hành" bằng INVALID_ARGUMENT + HTTP 400 (không phải NotFound/404),
// trùng mã với lỗi nhập sai định dạng. Chỉ metadata.error_name phân biệt được 2 trường hợp.
const isNotFoundError = (error) =>
  isRestError(error) && error.grpcCode === GRPC_CODE.INVALID_ARGUMENT && !isValidationError(error);

// "Không tìm thấy" là kết quả hợp lệ chứ không phải lỗi: trả về như dữ liệu để TanStack Query
// cache lại và không chạy retry.
export const fetchPublicWarranty = async (serial, { signal } = {}) => {
  try {
    const { data } = await restClient.get(PUBLIC_WARRANTY_PATH, { params: { serial_imei: serial }, signal });
    return { found: true, warrantyInfo: data?.warrantyInfo };
  } catch (error) {
    if (isNotFoundError(error)) return { found: false };
    throw error;
  }
};
